var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSheet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Dynamiques / Icones / Illustratif / Document") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dynamiques-/-Icones-/-Illustratif-/-Document",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-1",
    stroke: "#292927",
    strokeWidth: 1.2,
    points: "31.618 9 15 9 15 51 45 51 45 22.592"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.6697,
    y1: 28.4131,
    x2: 39.3297,
    y2: 28.4131,
    id: "Stroke-3",
    stroke: "#292927",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.6697,
    y1: 35.211,
    x2: 39.3297,
    y2: 35.211,
    id: "Stroke-4",
    stroke: "#292927",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.6697,
    y1: 42.0088,
    x2: 39.3297,
    y2: 42.0088,
    id: "Stroke-5",
    stroke: "#292927",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-6",
    stroke: "#292927",
    strokeWidth: 1.2,
    points: "31.618 9 31.618 22.592 45 22.592"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSheet);
export default __webpack_public_path__ + "static/media/icon-sheet.b714ffd5b1e9c88589adf296565f7a17.svg";
export { ForwardRef as ReactComponent };